<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-2" content-class="text-primary">
              <b-tab active class="border-0">
                <template v-slot:title>Modules</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Dashboard</th><th>Patients</th><th>Doctor</th><th v-if="showPsychologyPermissions">Psychology</th><th>Laboratory</th><th>Finance</th><th>Pharmacy</th><th>Reports</th><th>Settings</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.view_dashboard==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_dashboard')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_dashboard')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_patients==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_patients')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_patients')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_doctor==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_doctor')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_doctor')" /></span>
                  </td>
                  <td v-if="showPsychologyPermissions">
                    <span v-if="item.view_psychology==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_psychology')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_psychology')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_radiography==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_radiography')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_radiography')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_finance==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_finance')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_finance')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_pharmacy==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_pharmacy')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_pharmacy')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_reports==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_reports')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_reports')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_settings==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_settings')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_settings')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <b-tab>
                <template v-slot:title>Patients</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Add Patients</th><th>Patient Triage</th><th>Patient Visits</th><th>View Patients</th><th>Appointments</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.new_patient==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='new_patient')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='new_patient')" /></span>
                  </td>
                  <td>
                    <span v-if="item.patient_triage==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='patient_triage')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='patient_triage')" /></span>
                  </td>
                  <td>
                    <span v-if="item.patient_visits==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='patient_visits')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='patient_visits')" /></span>
                  </td>
                  <td>
                    <span v-if="item.patient_view==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='patient_view')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='patient_view')" /></span>
                  </td>
                  <td>
                    <span v-if="item.patient_appointments==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='patient_appointments')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='patient_appointments')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <b-tab v-if="showPsychologyPermissions">
                <template v-slot:title>Psychology</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Consultations</th><th>Group Therapies</th><th>Assessments & Tests</th><th>Corporate Services</th><th>Sensitive Services</th><th>Create Psychology Patient</th><th>Edit Psychology Patient</th><th>Delete Psychology Patient</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.psychology_consultations==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='psychology_consultations')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='psychology_consultations')" /></span>
                  </td>
                  <td>
                    <span v-if="item.psychology_group_programs==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='psychology_group_programs')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='psychology_group_programs')" /></span>
                  </td>
                  <td>
                    <span v-if="item.psychology_assessments_tests==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='psychology_assessments_tests')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='psychology_assessments_tests')" /></span>
                  </td>
                  <td>
                    <span v-if="item.psychology_corporate_services==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='psychology_corporate_services')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='psychology_corporate_services')" /></span>
                  </td>
                  <td>
                    <span v-if="item.psychology_sensitive_services==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='psychology_sensitive_services')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='psychology_sensitive_services')" /></span>
                  </td>
                  <td>
                    <span v-if="item.create_psychology_patient==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='create_psychology_patient')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='create_psychology_patient')" /></span>
                  </td>
                  <td>
                    <span v-if="item.edit_psychology_patient==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='edit_psychology_patient')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='edit_psychology_patient')" /></span>
                  </td>
                  <td>
                    <span v-if="item.delete_psychology_patient==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='delete_psychology_patient')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='delete_psychology_patient')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <b-tab>
                <template v-slot:title>Doctor</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Consultation</th><th>Procedure</th><th>Dental</th><th>Antenatal</th><th>Radiology</th><th>Others</th><th>Discharge</th><th>Referrals</th><th>Consent form</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.consultation_patients==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='consultation_patients')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='consultation_patients')" /></span>
                  </td>
                  <td>
                    <span v-if="item.procedure_patients==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='procedure_patients')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='procedure_patients')" /></span>
                  </td>
                  <td>
                    <span v-if="item.dental_patients==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='dental_patients')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='dental_patients')" /></span>
                  </td>
                  <td>
                    <span v-if="item.antenatal_patients==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='antenatal_patients')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='antenatal_patients')" /></span>
                  </td>
                  <td>
                    <span v-if="item.radiology_patients==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='radiology_patients')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='radiology_patients')" /></span>
                  </td>
                  <td>
                    <span v-if="item.other_patients==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='other_patients')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='other_patients')" /></span>
                  </td>
                  <td>
                    <span v-if="item.dischargepatient==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='dischargepatient')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='dischargepatient')" /></span>
                  </td>
                  <td>
                    <span v-if="item.consentform==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='consentform')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='consentform')" /></span>
                  </td>
                  <td>
                    <span v-if="item.referpatient==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='referpatient')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='referpatient')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <b-tab>
                <template v-slot:title>Laboratory</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Pick Test Samples</th><th>Enter Test Results</th><th>Test Results Report</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.pick_tests_samples==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='pick_tests_samples')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='pick_tests_samples')" /></span>
                  </td>
                  <td>
                    <span v-if="item.enter_test_results==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='enter_test_results')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='enter_test_results')" /></span>
                  </td>
                  <td>
                    <span v-if="item.test_results_report==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='test_results_report')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='test_results_report')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <b-tab>
                <template v-slot:title>Finance</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Patients Payments</th><th>Patient Debts</th><th>Insurance Patient</th><th>Saving Scheme</th><th>Expenses</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.patient_payments==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='patient_payments')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='patient_payments')" /></span>
                  </td>
                  <td>
                    <span v-if="item.patient_debts==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='patient_debts')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='patient_debts')" /></span>
                  </td>
                  <td>
                    <span v-if="item.insurance_patients==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='insurance_patients')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='insurance_patients')" /></span>
                  </td>
                  <td>
                    <span v-if="item.saving_scheme==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='saving_scheme')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='saving_scheme')" /></span>
                  </td>
                  <td>
                    <span v-if="item.view_expenses==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='view_expenses')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='view_expenses')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <b-tab>
                <template v-slot:title>Pharmacy</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Dispence Medicine</th><th>Sell Medicine</th><th>Add Stock</th><th>Stock Levels</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.dispense_medicine==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='dispense_medicine')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='dispense_medicine')" /></span>
                  </td>
                  <td>
                    <span v-if="item.sell_medicine==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='sell_medicine')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='sell_medicine')" /></span>
                  </td>
                  <td>
                    <span v-if="item.add_stock==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='add_stock')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='add_stock')" /></span>
                  </td>
                  <td>
                    <span v-if="item.stock_levels==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='stock_levels')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='stock_levels')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <!--app appointments-->
              <b-tab>
                <template v-slot:title>Appointments</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Appointment Manager</th><th>Bookings</th><th>Doctor Specialty</th><th>Drug Orders</th><th>Shedules</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.appointment_manager==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='appointment_manager')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='appointment_manager')" /></span>
                  </td>
                  <td>
                    <span v-if="item.app_bookings==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='app_bookings')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='app_bookings')" /></span>
                  </td>
                  <td>
                    <span v-if="item.doctor_specialty==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='doctor_specialty')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='doctor_specialty')" /></span>
                  </td>
                  <td>
                    <span v-if="item.drug_orders==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='drug_orders')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='drug_orders')" /></span>
                  </td>
                  <td>
                    <span v-if="item.schedules==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='schedules')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='schedules')" /></span>
                  </td>
                </tr>
                </tbody>
                </table>
              </b-tab>
              <!-- system settings -->
              <b-tab>
                <template v-slot:title>System Settings</template>
                <table class="table table-hover mt-2" style="color: black;">
                <thead><tr><th>Role Name</th><th>Edit Service cost</th><th>Edit Finance</th></tr></thead>
                <tbody>
                <tr v-for="item in permissions" :key="item.id">
                  <td>{{ item.rolename }}</td>
                  <td>
                    <span v-if="item.edit_service_cost==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='edit_service_cost')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='edit_service_cost')" /></span>
                  </td>

                  <td>
                    <span v-if="item.edit_finance==1"><RockerSwitch :value="true" @change="changePermission(role=item.role,permission='edit_finance')" /></span>
                    <span v-else><RockerSwitch :value="false" @change="changePermission(role=item.role,permission='edit_finance')" /></span>
                  </td>

                </tr>
                </tbody>
                </table>
              </b-tab>
            </b-tabs>
            </div>
          </div>
        </div>
      </div>
    
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import RockerSwitch from "vue-rocker-switch";
  import "vue-rocker-switch/dist/vue-rocker-switch.css";

  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { permissionMethods, permissionComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "System Permissions",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader,RockerSwitch
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "System Permissions",
        items: [ {text: "Dashboard",to: "/",}, {text: "System Permissions",active: true, }, ],
        isBusy: true,
        role:'',
        permission:'',
      };
    },
    computed: {
      ...permissionComputed,
      showPsychologyPermissions() { return this.userData?.settings?.psychology == 1; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.permissions.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.permissions.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchPermissions();
      this.isBusy=false;
    },
    methods: {
      ...permissionMethods,
      async changePermission(role,permission) {
        this.role=role; 
        this.permission=permission;
        let formData = new FormData();
        formData.append("role", this.role);
        formData.append("permission", this.permission);
        let url = "/updatepermission";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchPermissions();
            this.role="";
            this.permission="";
        }
        });
      },
    },
  };
  </script>
